/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import App from "./App";
import "./lib/icons";
import "./assets/styles/globals.css";

// Routes map to sections and the app scrolls to them itself; the browser
// restoring an old offset on reload would fight that.
if ("scrollRestoration" in history) history.scrollRestoration = "manual";

const elem = document.getElementById("root")!;
const app = <App />;

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
